import { PureComponent, type ReactNode } from "react";

export class IconButtonSkeleton extends PureComponent {
  render(): ReactNode {
    return (
      <div className="animate-pulse flex flex-col items-center border border-neutral-500 rounded py-4 px-4 md:px-8 cursor-pointer hover:border-primary md:max-w-[250px] md:w-[250px]">
        <div className="mb-2">
          <div className="w-9 bg-black-300 h-9 mb-2 rounded-md" />
        </div>
        <div className="font-serif text-sm w-full">
          <div className="w-full bg-black-300 h-4 mb-2 rounded-md" />
        </div>
      </div>
    );
  }
}
